import type { DriveStep } from "driver.js";
import { ONBOARDING_IDS } from "../constants";

export const teamCompareSteps: DriveStep[] = [
    {
        element: `#${ONBOARDING_IDS.COMPARE_PLAYER_SELECT}`,
        popover: {
            title: "Select Players to Compare",
            description:
                "Choose up to two players — one from Vålerenga and one from the opponent team — using the team group toggles. " +
                "Once a group is active, the dropdown lists every player in that squad for the current tournament.",
            side: "bottom",
            align: "start",
        },
    },
    {
        element: `#${ONBOARDING_IDS.COMPARE_STATS_TABLE}`,
        popover: {
            title: "Side-by-Side KPI Table",
            description:
                "Each KPI category is shown on its own row with both players' scores side by side, " +
                "so you can instantly see who leads in Defensive, Offensive, Team Play, Effort, and Bonus points.",
            side: "top",
            align: "center",
        },
    },
    {
        element: `#${ONBOARDING_IDS.COMPARE_RADAR}`,
        popover: {
            title: "Radar Chart",
            description:
                "A spider chart that visualises each player's strengths and weaknesses across all KPI dimensions simultaneously. " +
                "Larger coverage in a segment means higher performance in that area.",
            side: "top",
            align: "center",
        },
    },
    {
        element: `#${ONBOARDING_IDS.COMPARE_PERFORMANCE}`,
        popover: {
            title: "Match-by-Match Performance",
            description:
                "A line chart plotting each player's KPI score across individual matches in the tournament. " +
                "Switch between KPI tabs to focus on a specific category, and toggle trend lines or filter to common matches " +
                "to see how the players fared against shared opponents.",
            side: "top",
            align: "center",
        },
    },
];
